var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"infographics-view"},[_c('v-img',{staticClass:"infographics",attrs:{"max-width":"1280","src":"/img/faq/consult-later-infographics.jpg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }